import React, { useState, useEffect, Fragment } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import { useForm } from "react-hook-form";
import axiosConfig from "../../services/axiosConfig";
import setHeader from "../../components/Functions/setHeader";
import SweetAlert from 'sweetalert2';
import LoadingComponent from "../../components/common/LoadingComponent";
import NoDataHandler from "../../components/common/NoDataHandler";


const Category = () => {
    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();
    const [data, setData] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editId, setEditId] = useState(null);
    const [categoryImage, setCategoryImage] = useState(null);
    const [existingImageUrl, setExistingImageUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const [fetchLoading, setFetchLoading] = useState(false);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        setFetchLoading(true);
        setData([]); // Reset data before fetching new data

        axiosConfig.get("category-list", setHeader())
            .then((res) => {
                setData(res.data.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })
            .finally(() => {
                setFetchLoading(false);
            });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        const input = e.target; // capture input for reset
        const maxSize = 15 * 1024; // 15KB

        // Check file type
        if (file.type !== 'image/png') {
            SweetAlert.fire({
                title: "Validation Error",
                text: `Only PNG images are allowed.`,
                icon: "warning",
            }).then(() => input.value = ""); // reset file input
            return;
        }

        // Check file size
        if (file.size > maxSize) {
            SweetAlert.fire({
                title: "Validation Error",
                text: `File size must be 15KB or less.`,
                icon: "warning",
            }).then(() => input.value = ""); // reset file input
            return;
        }

        // Check image dimensions
        const img = new Image();
        img.onload = () => {
            if (img.width > 130 || img.height > 80) {
                SweetAlert.fire({
                    title: "Validation Error",
                    text: `Image must be max 130px wide and 80px tall.`,
                    icon: "warning",
                }).then(() => input.value = ""); // reset file input
                return;
            }

            setCategoryImage(file); // valid file
        };
        img.onerror = () => {
            SweetAlert.fire({
                title: "Invalid Image",
                text: `Could not load the image.`,
                icon: "error",
            }).then(() => input.value = ""); // reset file input
        };
        img.src = URL.createObjectURL(file);
    };



    const onSubmit = data => {
        setLoading(true);
        try {
            if (data !== '') {
                // Create FormData for handling file upload
                const formData = new FormData();
                formData.append("name", data.name);
                formData.append("desc", data.desc || "");
                formData.append("status", data.status ? 1 : 0);
                formData.append("category_order", data.category_order || "");

                if (editMode) {
                    formData.append("id", editId);

                    // Handle image for edit mode
                    if (categoryImage) {
                        // New image selected
                        formData.append("category_image", categoryImage);
                    } else if (existingImageUrl) {
                        // Keep existing image
                        formData.append("existing_image_url", existingImageUrl);
                        formData.append("keep_existing_image", "1");
                    }

                    for (let pair of formData.entries()) {
                        console.log(pair[0] + ": " + pair[1]);
                    }

                    axiosConfig.post(`update-category/${editId}`, formData, setHeader()).then((res) => {
                         if (res.data.error && res.data.messages === 'Category name already exists!') {
                        SweetAlert.fire({
                            title: "Error",
                            text: "Category name already exists!",
                            icon: "warning",
                        });
                        return; // STOP here
                    }
                        if (!res.data.error) {
                            SweetAlert.fire({ title: "Success", text: "Updated Successfully", icon: "success" });
                            resetForm();
                            getData();
                        } else {
                            SweetAlert.fire({ title: "Oops!", text: "Failed to update. Try again!", icon: "error" });
                        }
                    }).catch((error) => {
                        console.log(error);
                        SweetAlert.fire({ title: "Error", text: "Something went wrong. Please try again!", icon: "error" });
                    }).finally(() => {
                        setLoading(false);
                    });
                } else {
                    // Add mode - image is optional
                    if (categoryImage) {
                        formData.append("category_image", categoryImage);
                    }

                    console.log('Add mode FormData contents:');
                    for (let pair of formData.entries()) {
                        console.log(pair[0] + ": " + pair[1]);
                    }

                    axiosConfig.post("insert-category", formData, setHeader()).then((res) => {
                         if (res.data.error && res.data.messages === 'Exist a Category in this name !') {
                        SweetAlert.fire({
                            title: "Error",
                            text: "Category name already exists!",
                            icon: "warning",
                        });
                        return; // STOP here
                    }
                        if (!res.data.error) {
                            SweetAlert.fire({ title: "Success", text: "Inserted Successfully", icon: "success" });
                            resetForm();
                            getData();
                        } else {
                            SweetAlert.fire({ title: "Oops!", text: "Failed to insert. Try again!", icon: "error" });
                        }
                    }).catch((error) => {
                        console.log(error);
                        SweetAlert.fire({ title: "Error", text: "Something went wrong. Please try again!", icon: "error" });
                    }).finally(() => {
                        setLoading(false);
                    });
                }
            } else {
                errors.showMessages();
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            SweetAlert.fire({ title: "Error", text: "Something went wrong. Please try again!", icon: "error" });
            setLoading(false);
        }
    };

    const resetForm = () => {
        reset();
        setCategoryImage(null);
        setExistingImageUrl("");
        setEditMode(false);
        setEditId(null);

        // Reset file input
        const fileInput = document.getElementById("categoryImage");
        if (fileInput) fileInput.value = "";
    };

    const editData = (id) => {
        const categoryToEdit = data.find((item) => item.id === id);
        if (categoryToEdit) {
            setEditMode(true);
            setEditId(id);
            // Populate form fields
            setValue("name", categoryToEdit.name);
            setValue("desc", categoryToEdit.description);
            setValue("status", categoryToEdit.status == 1);
            setValue("category_order", categoryToEdit.category_order || "");
            // Set existing image URL for display
            setExistingImageUrl(categoryToEdit.category_image || "");
            setCategoryImage(null); // Reset file input
        }
    };

    const DeleteData = (id) => {
        SweetAlert.fire({
            title: 'Are you sure?',
            text: "Once deleted, you will not be able to recover this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                axiosConfig.get(`delete-category/${id}`, setHeader())
                    .then((res) => {
                        if (!res.data.error) {
                            SweetAlert.fire({
                                title: "Success",
                                text: res.data.messages,
                                icon: "success",
                            });
                            getData(); // Refresh the list
                        } else {
                            SweetAlert.fire({
                                title: "Oops!",
                                text: res.data.messages,
                                icon: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        console.error("Error deleting data:", error);
                        SweetAlert.fire({
                            title: "Error",
                            text: "An error occurred while deleting the data.",
                            icon: "error",
                        });
                    });
            }
        });
    };

    if (loading || fetchLoading) {
        return (
            <LoadingComponent />
        );
    }
    if (data.length === 0) {
        return <NoDataHandler title='No Category Fount' />;
    }

    return (
        <Fragment>
            <Breadcrumb title="Category" parent="Masters" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-5">
                        <div className="card">
                            <div className="card-body">
                                <form className="needs-validation" noValidate="" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="form-row">
                                        <div className="col-md-12 mb-3">
                                            <label htmlFor="validationCustom01">Category <span style={{ color: 'red', fontSize: '21px' }}>*</span></label>
                                            <input
                                                className="form-control"
                                                name="name"
                                                type="text"
                                                placeholder="Category"
                                                {...register('name', { required: true })}
                                                disabled={loading}
                                            />
                                            <span>{errors.name && 'Category is required'}</span>
                                            <div className="valid-feedback">{"Looks good!"}</div>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label>Description</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                cols="5"
                                                name="desc"
                                                placeholder="Description..."
                                                {...register('desc', { required: false })}
                                                disabled={loading}
                                            ></textarea>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label htmlFor="category_order">Category Order</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="category_order"
                                                placeholder="Enter display order"
                                                {...register("category_order", { required: false })}
                                            />
                                        </div>

                                        <div className="col-md-12 mb-3">
                                            <label htmlFor="categoryImage">Category Image {editMode && "(Leave empty to keep current image)"}</label>

                                            {/* Show existing image in edit mode */}
                                            {editMode && existingImageUrl && (
                                                <div className="existing-image-preview mb-2">
                                                    <img
                                                        src={existingImageUrl}
                                                        alt="Current category"
                                                        style={{
                                                            maxWidth: "150px",
                                                            maxHeight: "100px",
                                                            objectFit: "cover",
                                                            border: "1px solid #ddd",
                                                            borderRadius: "4px"
                                                        }}
                                                    />
                                                    <p className="text-muted mt-1 mb-0" style={{ fontSize: "12px" }}>Current Image</p>
                                                </div>
                                            )}
                                            <small className="text-muted">PNG only | Max size: 15KB | Max dimensions: 130×80</small>

                                            <input
                                                type="file"
                                                id="categoryImage"
                                                name="category_image"
                                                onChange={handleImageChange}
                                                className="form-control"
                                                accept="image/*"
                                                disabled={loading}
                                            />

                                            {categoryImage && (
                                                <div className="file-preview mt-1">
                                                    <small className="text-info">New file selected: {categoryImage.name}</small>
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-md-12 checkbox checkbox-solid-primary mb-3">
                                            <input
                                                id="solid3"
                                                type="checkbox"
                                                value="1"
                                                name="status"
                                                {...register('status', { required: false })}
                                                defaultChecked
                                                disabled={loading}
                                            />
                                            <label htmlFor="solid3">Active</label>
                                        </div>
                                    </div>
                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                {editMode ? 'Updating...' : 'Saving...'}
                                            </>
                                        ) : (
                                            editMode ? 'Update' : 'Save'
                                        )}
                                    </button>
                                    {(editMode || categoryImage) && (
                                        <button
                                            className="btn btn-secondary"
                                            style={{ marginLeft: '10px' }}
                                            type="button"
                                            onClick={resetForm}
                                            disabled={loading}
                                        >
                                            Reset
                                        </button>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-7">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">{"#"}</th>
                                        <th scope="col">{"Order"}</th>
                                        <th scope="col">{"Category"}</th>
                                        <th scope="col">{"Image"}</th>
                                        <th scope="col">{"Status"}</th>
                                        <th scope="col">{"Action"}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <th scope="row">{index + 1}</th>
                                                <th scope="row">{item.category_order}</th>
                                                <td>{item.name}</td>
                                                <td>
                                                    {item.category_image ? (
                                                        <img
                                                            src={item.category_image}
                                                            alt={item.name}
                                                            style={{
                                                                width: "40px",
                                                                height: "40px",
                                                                objectFit: "cover",
                                                                borderRadius: "4px"
                                                            }}
                                                        />
                                                    ) : (
                                                        <span className="text-muted">No Image</span>
                                                    )}
                                                </td>
                                                <td>{item.status == 1 ? "Active" : "Inactive"}</td>
                                                <td>
                                                    <button
                                                        title="Edit"
                                                        className="btn btn-xs btn-outline-success"
                                                        onClick={(e) => { editData(item.id) }}
                                                        disabled={loading}
                                                    >
                                                        Edit
                                                    </button>&nbsp;
                                                    <button
                                                        title="Delete"
                                                        className="btn btn-xs btn-outline-danger"
                                                        onClick={(e) => DeleteData(item.id)}
                                                        disabled={loading}
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Category;